function blockThematicImageResize(){
    const blockThemathics = document.querySelectorAll('.block-thematic > .content > .inner');
    if (blockThemathics) {
        blockThemathics.forEach(block => {

            /**
            * Call Splide plugin
            */
            new Splide(block, {
                drag: false,
                perMove: 1,
                pagination: false,
                arrows: false,
                breakpoints:{
                    680: {
                        pagination: true,
                    }
                }
            }).mount();

            /** Resize images */
            var slider = block.querySelector(".container-description");
            var sliderImages = slider.querySelectorAll('.image');

            sliderImages.forEach(imageElement => {
                if(slider){
                    var imageContainerWidth = slider.clientWidth;

                    if(window.innerWidth >= 1640){
                        var squareImageWidth = (imageContainerWidth * 0.33) - 30;
                    } else if(window.innerWidth >= 680 && window.innerWidth < 1640){
                        var squareImageWidth = (imageContainerWidth * 0.33) - 20;
                    }else if(window.innerWidth < 680){
                        var squareImageWidth = (imageContainerWidth * 0.75);
                    }

                    imageElement.style.cssText = 'max-height:' + squareImageWidth + 'px;'+'height:' + squareImageWidth + 'px';
                    imageElement.querySelectorAll('img').forEach(imageTag => {
                        imageTag.style.cssText = 'max-height:' + squareImageWidth + 'px;'+'height:' + squareImageWidth + 'px';
                    });
                }
            });

        });
    }
}

function moveSplideArrows(){
    const splidePageNumberContainers = document.querySelectorAll('.block-category .content');
    if(splidePageNumberContainers){
        splidePageNumberContainers.forEach(container => {
            var pageNumber = container.querySelector('.page-number');
            var splideNextArrow = container.querySelector('.splide__arrow--next');
            if(pageNumber && splideNextArrow){
                splideNextArrow.before(pageNumber);
            }
        });
    }
}

function blockJoinUsImageResize(){
    if(window.innerWidth > 680){
        var imageElement = document.querySelector('.block-join-us > .content > .inner > .container-description > .images');
        if(imageElement){
            imageElement.querySelectorAll('.image').forEach(imageTag => {
                var squareImageWidth = imageTag.clientWidth * 0.64;
                imageTag.style.cssText = imageTag.style.cssText + ';max-height:' + squareImageWidth + 'px;'+'height:' + squareImageWidth + 'px';
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    blockThematicImageResize();
    moveSplideArrows();
    blockJoinUsImageResize();
});

// window.addEventListener("resize", function(){
//     blockThematicImageResize();
//     moveSplideArrows();
//     blockJoinUsImageResize();
// });